// Whether an install affordance can be offered at all.
export function computeCanInstall(a: { isInstalled: boolean; isIOS: boolean; hasDeferred: boolean }): boolean {
  return !a.isInstalled && (a.isIOS || a.hasDeferred);
}

// Whether the auto-banner should appear (installable and not yet dismissed).
export function shouldShowBanner(a: { canInstall: boolean; bannerDismissed: boolean }): boolean {
  return a.canInstall && !a.bannerDismissed;
}
